const parameters = [
  {
    name: "Danceability",
    id: "danceability",
    checked: false,
    description: "The suitability of the track for dancing based on a combination of musical elements including tempo, rhythm stability, beat strength, and overall regularity."
  },
  {
    name: "Duration",
    id: "duration",
    checked: false, 
    description: "The duration of the track in milliseconds."
  },
  {
    name: "Energy",
    id: "energy",
    checked: false,
    description: "The perceptual measure of intensity and activity of a track. Typically, energetic tracks feel fast, loud, and noisy. For example, death metal has high energy, while a Bach prelude scores low on the scale."
  },
  {
    name: "Key",
    id: "key",
    checked: false,
    description: "The estimated overall key of the track, including its modality (major or minor)."
  },
  {
    name: "Tempo",
    id: "tempo",
    checked: false,
    description: "The overall estimated tempo of a track in beats per minute (BPM)."
  },
  {
    name: "Valence",
    id: "valence",
    checked: false,
    description: "The musical positiveness conveyed by a track. Tracks with high valence sound more positive (e.g. happy, cheerful, euphoric), while tracks with low valence sound more negative (e.g. sad, depressed, angry)."
  }
];

export default parameters;